import { ColoursObj } from "@eventr/common-storybook";
import { useEffect, useState } from "react";
import { useHomeScrollAway } from "feat/home/home-scroll-away";
import { useIsTwoPane } from "feat/layout/screen-layout";
import { useScrollContext } from "state/scrollState/scrollContext";
import { useSplitStore } from "feat/nativeNavigation/split.store";
import { useHasVerticalBar } from "feat/nativeNavigation/vertical-bar";

export function CarouselContainer({ children }: { children: React.ReactNode }) {
  const [atTop, setAtTop] = useState(useScrollContext.getState().atTop);
  const { setHeader } = useHomeScrollAway();
  // Curves into the trailing pane when it heads the leading pane.
  const twoPane = useIsTwoPane();
  // Connect to the store on mount, disconnect on unmount, catch state-changes in a reference
  useEffect(() => useScrollContext.subscribe((state) => setAtTop(state.atTop)), [setAtTop]);
  // A folded iPhone Duo's vertical bar sits beside the header, whose picture runs on under it to
  // the screen's edge. Everything over the picture stays in the column: it is all placed from
  // these, which are 0 everywhere else.
  const collapsed = useSplitStore((s) => s.collapsed);
  const bleeds = useHasVerticalBar() && collapsed;
  return (
    <div
      ref={setHeader}
      // className="carousel-container"
      style={{
        position: "fixed",
        top: 0,
        ...(bleeds && {
          "--header-bleed-left": "env(safe-area-inset-left, 0px)",
          "--header-bleed-right": "env(safe-area-inset-right, 0px)",
        }),
        left: "calc(-1 * var(--header-bleed-left, 0px))",
        right: "calc(-1 * var(--header-bleed-right, 0px))",
        zIndex: 100,
        backgroundColor: ColoursObj.backgrounds.header,
        borderBottom: atTop || twoPane ? "" : `solid 2px ${ColoursObj.core.secondary}`,
        ...(twoPane && { borderBottomRightRadius: "64px", overflow: "hidden" }),
      }}
    >
      {children}
    </div>
  );
}
